import React from "react";
import "./About.css";

export default function About() {
    return (
        <>
            <section id="about">
                <div id="about-container">
                    <div className="about-headline">
                        <p> Get To Know </p>
                        <h1> About Me </h1>
                    </div>

                    <div className="about-content">
                        <div className="about-image">
                            <img src="/about/about-me.jpg" alt="" />
                        </div>

                        <div className="about-biodata">
                            <div className="about-cards-grid">
                                <div className="about-cards">
                                    <span class="material-symbols-outlined">
                                        {" "}
                                        work_history{" "}
                                    </span>
                                    <h3> Experience </h3>
                                    <p> 3+ Years of Learning </p>
                                </div>

                                <div className="about-cards">
                                    <span class="material-symbols-outlined">
                                        {" "}
                                        groups{" "}
                                    </span>
                                    <h3> Clients </h3>
                                    <p> 15+ Locals </p>
                                </div>

                                <div className="about-cards">
                                    <span class="material-symbols-outlined">
                                        {" "}
                                        folder{" "}
                                    </span>
                                    <h3> Projects </h3>
                                    <p> 20+ Completed </p>
                                </div>
                            </div>

                            <div className="about-me-introduction">
                                <p>
                                    I'm <b> Owen Marscel</b>, a student at Bunda Mulia
                                    University, specializing in <b> Full-Stack Web
                                    Development </b>. I also provide task completion
                                    services within the university. Welcome to
                                    my portfolio, where you can explore my
                                    projects and experiences in the world of web
                                    development.
                                </p>
                            </div>

                            <div className="about-me-button">
                                <a href="#contact">
                                    <button> Let's Talk! </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
